import React from 'react';
import {EditDialog} from '../../../../components/edit-dialog/edit_dialog';
import SimpleEditor from '../../../../components/editor/simple_editor';
import {
    Button,
    DialogActions,
    DialogTitle,
    TextField,
    withStyles,
    DialogContent,
    InputLabel,
} from 'material-ui';
import {styles} from '../../style/staff_section';

class TripFormatsSectionEditPopup extends React.Component {
    render() {
        let {
            title,
            body,
            classes,
            onHandleSubmit,
            onHandleClose,
            onUpdateTitleField,
            onUpdateBodyField,
        } = this.props;

        return (
            <EditDialog
                open={this.props.open}
                classes={{
                    paper: classes.paper,
                    fullWidth: classes.fullWidth,
                }}
            >
                <DialogTitle>Edit Trip Formats Snippets Section</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="title"
                        label="Title"
                        onChange={(event) => {
                            onUpdateTitleField(event.target.value);
                        }}
                        fullWidth
                        value={title || ''}
                    />
                    <InputLabel className="simpleEditorLabelPages">
                        Body
                    </InputLabel>
                    <SimpleEditor
                        initialValue={body}
                        onChange={(htmlBody) => {
                            onUpdateBodyField(htmlBody);
                        }}
                    />
                </DialogContent>
                <DialogActions className={classes.dialogActionsBtn}>
                    <Button
                        variant="raised"
                        onClick={(ev) => onHandleClose(ev)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="raised"
                        onClick={(ev) => onHandleSubmit(ev)}
                        color="primary"
                    >
                        Done
                    </Button>
                </DialogActions>
            </EditDialog>
        );
    }
}

export default withStyles(styles)(TripFormatsSectionEditPopup);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/trip_formats_section_edit.js